import { aiJobHistoryFeedKeys } from '@/ai/jobs/client/history-feed-keys';
import { creditsKeys } from '@/hooks/credits/use-credits';
import { paymentKeys } from '@/hooks/payment/use-payment';
import type { QueryClient } from '@tanstack/react-query';

export function clearAuthScopedQueryCache(queryClient: QueryClient) {
  queryClient.removeQueries({
    queryKey: aiJobHistoryFeedKeys.all,
  });
  queryClient.removeQueries({
    queryKey: creditsKeys.all,
  });
  queryClient.removeQueries({
    queryKey: paymentKeys.all,
  });
}
